import { put } from 'redux-saga/effects'
import { push } from 'connected-react-router';
import loginApi from "../services/loginApi";

let api = new loginApi();

export function* logout() {
    try {
        let { data } = yield api.logoutNew();
        let getItem = localStorage.getItem('pageUrl');
        console.log("data logout data", data,"pagename",getItem);
        localStorage.clear();
        yield put(push('/reportutility'));
    } catch (e) {
        window.location.href = "/reportutility";
    }
}

